const urls = {
    FISCAL_NOTIFICATION: 'fiscal-notification',
    FISCAL_NOTIFICATION_DETAIL: 'fiscal-notification/detail',
    FISCAL_NOTIFICATION_DETAIL_BY_HEADER: 'fiscal-notification-detail-by-header',
    FISCAL_NOTIFICATION_HEADER: 'fiscal-notification-header',
    FISCAL_NOTIFICATION_REINSERT_TANK: 'fiscal-notification-detail-reinsert-tank',
    FISCAL_NOTIFICATION_TANK: 'fiscal-notification-tank',
    FISCAL_CIRCUITS: 'masterdata/fiscal-circuit-combo',
    FISCAL_NOTIFICATION_UPDATE: 'fiscal-notification-update-fiscal-notification',
    FISCAL_NOTIFICATION_LOAD: 'fiscal-notification-load-fiscal-notification',
    FISCAL_NOTIFICATION_DELETE: 'fiscal-notification-delete',
    FISCAL_NOTIFICATION_COMBO: 'fiscal-notification-combo',
    FISCAL_NOTIFICATION_LAYOUT: 'fiscal-notification-layout',

    FISCAL_NOTIFICATION_HEADER_NEXT: 'fiscal-notification-header-next',
    FISCAL_NOTIFICATION_DETAIL_NEXT: 'fiscal-notification-detail-next',
    FISCAL_NOTIFICATION_LAYOUT_NEXT: 'fiscal-notification-layout-next',
    FISCAL_NOTIFICATION_CHECK_FOR_UPDATE: 'fiscal-notification-check-for-update',
    FISCAL_NOTIFICATION_SEND: 'fiscal-notification-send',
    FISCAL_NOTIFICATION_RESEND: 'fiscal-notification-infoil-send',

    FISCAL_NOTIFICATION_NEXT_STATE: 'fiscal-notification-next-state-for-basic-changes',

    FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT: 'fiscal-notification-biodiesel-mixing-report',
    FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_LOAD_DATA: 'fiscal-notification-biodiesel-mixing-report-load-data',
    FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_LAST_AZZ_PD: 'fiscal-notification-biodiesel-mixing-report-last-azzeramento-piede',
    FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_TRAVASI_BIODIESEL_MIX: 'fiscal-notification-biodiesel-mixing-report-travasi-biodiesel-mix',
    FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_TRAVASI_BIODIESEL_PURO: 'fiscal-notification-biodiesel-mixing-report-travasi-biodiesel-puro',
    FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_PRINT_PREVIEW: 'fiscal-notification-biodiesel-mixing-report-print-preview',
    FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_PRINT: 'fiscal-notification-biodiesel-mixing-report-print-report',
    GET_AUTOCOMPLETE_PARTIAL_MEASURE_VALUES: 'fiscal-notification-detail-get-autocomplete-partial-measure-values',

    FISCAL_NOTIFICATION_MEASUREMENT_REPORT_INITIAL_DATA: 'fiscal-notification-measurement-report-get-initial-data',
    FISCAL_NOTIFICATION_CREATE_MEASUREMENT_REPORT: 'fiscal-notification-measurement-report',
    FISCAL_NOTIFICATION_MEASUREMENT_REPORT: 'fiscal-notification-measurement-report-print',

    FISCAL_NOTIFICATION_CAN_ADD_MEASURE: 'fiscal-notification-detail-can-add-measure',

    REPORT_A18_DOWNLOAD: 'fiscal-reports/a18-print',
    REPORT_A18_DOWNLOAD_EXCEL: 'fiscal-reports/a18-print-excel',
    REPORT_STOCK_SUMMARY_DOWNLOAD: 'fiscal-reports/stock-summary-print',
    REPORT_HTER9: 'fiscal-reports/hter9',
    REPORT_HTER9_DOWNLOAD: 'fiscal-reports/hter9-print',
    REPORT_ADDITIVE_DOWNLOAD: 'fiscal-reports/additive-print',

    EXCISE_FISCAL_REGISTER: 'excise-fiscal-register',
    EXCISE_FISCAL_REGISTER_CALCULATOR: 'excise-calculator/excise-calculator',
    EXCISE_FISCAL_REGISTER_BY_HEADER: 'fiscal-notification/add-excise-by-header-id',

    VERSALIS_MOVEMENTS_EXCEL: 'versalis-movements-excel',
    VERSALIS_MOVEMENTS_RAW_MATERIAL_EXCEL: 'versalis-movements-raw-material-excel',
    VERSALIS_MOVEMENTS_RAW_MATERIAL: 'versalis-movements-raw-material',
    VERSALIS_MOVEMENTS_RAW_MATERIAL_IMPORT: 'versalis-movements-raw-material-import',
    VERSALIS_MOVEMENTS_RAW_MATERIAL_LAST: 'versalis-movements-raw-material-last',

    VERSALIS_MOVEMENTS_REGISTER: 'versalis/loading-unloading-register',
    VERSALIS_MOVEMENTS_REGISTER_EXCEL: 'versalis/loading-unloading-register-excel',
    VERSALIS_MOVEMENTS_REGISTER_HTER14_STOCK: 'versalis/loading-unloading-register-hter14-stock'
}

import genericService from '../genericService';

export default {
    async getFiscalNotification(body, callback){
        await genericService.getItem(urls.FISCAL_NOTIFICATION, body).then(callback);
    },
    async getAllFiscalNotifications(body, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION, body).then(callback);
    },
    async getFiscalNotificationCombo(body, callback) {
        await genericService.getItem(urls.FISCAL_NOTIFICATION_COMBO, body).then(callback);
    },
    async getFiscalNotificationHeader(body, callback){
        await genericService.getItem(urls.FISCAL_NOTIFICATION_HEADER, body).then(callback);
    },
    async getFiscalNotificationDetailsByHeader(body, callback){
        await genericService.getItem(urls.FISCAL_NOTIFICATION_DETAIL_BY_HEADER, body).then(callback);
    },
    async updateFiscalNotification (body, callback){
        await genericService.put(urls.FISCAL_NOTIFICATION_DETAIL, body).then(callback);
    },
    async getFiscalNotificationReinsertTank(body, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_REINSERT_TANK, body).then(callback);
    },
    async getFiscalNotificationTank(body, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_TANK, body).then(callback);
    },
    async getFiscalCircuits(body, callback){
        await genericService.get(urls.FISCAL_CIRCUITS, body).then(callback);
    },
    // async updateFiscalNotification(body, callback){
    //     await genericService.post(urls.FISCAL_NOTIFICATION_UPDATE, body).then(callback);
    // },
    async getFiscalNotificationLoad(body, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_LOAD, body).then(callback);
    },
    async deleteFiscalNotification(id, callback){
        await genericService.delete(urls.FISCAL_NOTIFICATION, id).then(callback);
    },
    async getFiscalNotificationLayout(body, callback){
        await genericService.getItem(urls.FISCAL_NOTIFICATION_LAYOUT, body).then(callback);
    },
    async getFiscalNotificationHeaderNext(body, callback){
        await genericService.getItem(urls.FISCAL_NOTIFICATION_HEADER_NEXT, body).then(callback);
    },
    async getFiscalNotificationDetailNext(body, callback){
        await genericService.getItem(urls.FISCAL_NOTIFICATION_DETAIL_NEXT, body).then(callback);
    },
    async getFiscalNotificationLayoutNext(body, callback){
        await genericService.getItem(urls.FISCAL_NOTIFICATION_LAYOUT_NEXT, body).then(callback);
    },
    async getFiscalNotificationCheckForUpdate(body, callback){
        await genericService.getItem(urls.FISCAL_NOTIFICATION_CHECK_FOR_UPDATE, body).then(callback);
    },
    async sendFiscalNotification(body, callback){
        await genericService.post(urls.FISCAL_NOTIFICATION_SEND, body).then(callback);
    },
    async resendFiscalNotification(body, callback){
        await genericService.post(urls.FISCAL_NOTIFICATION_RESEND, body).then(callback);
    },
    async getFiscalNotificationNextState(body, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_NEXT_STATE, body).then(callback);
    },
    async printMeasurementReport(body, callback){
        await genericService.dowloadFile(urls.FISCAL_NOTIFICATION_MEASUREMENT_REPORT, body).then(callback);
    },
    async savePreviewBiodieselMixingReport(body, callback){
        await genericService.post(urls.FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_PRINT_PREVIEW, body).then(callback);
    },
    async printPreviewBiodieselMixingReport(body, callback){
        await genericService.dowloadFile(urls.FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_PRINT_PREVIEW, body).then(callback);
    },
    async printBiodieselMixingReport(body, callback){
        await genericService.dowloadFile(urls.FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_PRINT, body).then(callback);
    },
    async updateBiodieselMixingReport(body, callback){
        await genericService.put(urls.FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT, body).then(callback);
    },
    async addBiodieselMixingReport(body, callback){
        await genericService.post(urls.FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT, body).then(callback);
    },
    async getBiodieselMixingReport(body, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_LOAD_DATA, body).then(callback);
    },
    async getBiodieselMixingReportLastAzzPd(body, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_LAST_AZZ_PD, body).then(callback);
    },
    async getBiodieselMixingReportLTravBiodieselMix(body, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_TRAVASI_BIODIESEL_MIX, body).then(callback);
    },
    async getBiodieselMixingReportLTravBiodieselPuro(body, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_BIODIESEL_MIXING_REPORT_TRAVASI_BIODIESEL_PURO, body).then(callback);
    },
    async getAutocompletePartialMeasureValues(body, callback){
        await genericService.get(urls.GET_AUTOCOMPLETE_PARTIAL_MEASURE_VALUES, body).then(callback);
    },
    async getMeasurementReportInitialData(body, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_MEASUREMENT_REPORT_INITIAL_DATA, body).then(callback);
    },
    async createMeasurementReport(body, callback){
        await genericService.post(urls.FISCAL_NOTIFICATION_CREATE_MEASUREMENT_REPORT, body).then(callback);
    },
    async canAddMeasure(body, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_CAN_ADD_MEASURE, body).then(callback);
    },
    async printTanksMovementsListA18(body, callback){
        await genericService.dowloadFile(urls.REPORT_A18_DOWNLOAD, body).then(callback);
    },
    async printTanksMovementsListA18Excel(body, callback){
        await genericService.dowloadFile(urls.REPORT_A18_DOWNLOAD_EXCEL, body).then(callback);
    },
    async printtStockSummary(body, callback){
        await genericService.dowloadFile(urls.REPORT_STOCK_SUMMARY_DOWNLOAD, body).then(callback);
    },
    async printAdditive(body, callback){
        await genericService.dowloadFile(urls.REPORT_ADDITIVE_DOWNLOAD, body).then(callback);
    },
    async getHter9(body, callback){
        await genericService.get(urls.REPORT_HTER9, body).then(callback);
    },
    async printHter9(body, callback){
        await genericService.dowloadFile(urls.REPORT_HTER9_DOWNLOAD, body).then(callback);
    },

    // W Token
    async deleteFiscalNotificationWToken(id, token, callback){
        await genericService.deleteWToken(urls.FISCAL_NOTIFICATION, token, id).then(callback);
    },
    async sendFiscalNotificationWToken(body, token, callback){
        await genericService.postWToken(urls.FISCAL_NOTIFICATION_SEND, token, body).then(callback);
    },
    async resendFiscalNotificationWToken(body, token, callback){
        await genericService.postWToken(urls.FISCAL_NOTIFICATION_RESEND, token, body).then(callback);
    },

    async versalisMovementExcel(body, callback){
        await genericService.dowloadFile(urls.VERSALIS_MOVEMENTS_EXCEL, body).then(callback);
    },
    async versalisMovementRawMaterialExcel(body, callback){
        await genericService.dowloadFile(urls.VERSALIS_MOVEMENTS_RAW_MATERIAL_EXCEL, body).then(callback);
    },
    async versalisMovementRawMaterialImport(body, callback){
        await genericService.post(urls.VERSALIS_MOVEMENTS_RAW_MATERIAL_IMPORT, body).then(callback);
    },
    async updateVersalisMovementRawMaterial(body, callback){
        await genericService.put(urls.VERSALIS_MOVEMENTS_RAW_MATERIAL, body).then(callback);
    },
    async createVersalisMovementRawMaterial(body, callback){
        await genericService.post(urls.VERSALIS_MOVEMENTS_RAW_MATERIAL, body).then(callback);
    },
    async getVersalisMovementRawMaterialLast(callback){
        await genericService.get(urls.VERSALIS_MOVEMENTS_RAW_MATERIAL_LAST, {}).then(callback);
    },
    async getVersalisMovementRegister(body, callback){
        await genericService.get(urls.VERSALIS_MOVEMENTS_REGISTER, body).then(callback);
    },
    async createVersalisMovementRegister(body, callback){
        await genericService.post(urls.VERSALIS_MOVEMENTS_REGISTER, body).then(callback);
    },
    async updateVersalisMovementRegister(body, callback){
        await genericService.put(urls.VERSALIS_MOVEMENTS_REGISTER, body).then(callback);
    },
    async deleteVersalisMovementRegister(id, callback){
        await genericService.delete(urls.VERSALIS_MOVEMENTS_REGISTER, id).then(callback);
    },
    async getVersalisMovementRegisterHter14Stock(body, callback){
        await genericService.get(urls.VERSALIS_MOVEMENTS_REGISTER_HTER14_STOCK, body).then(callback);
    },
    async versalisMovementRegisterExcel(body, callback){
        await genericService.dowloadFile(urls.VERSALIS_MOVEMENTS_REGISTER_EXCEL, body).then(callback);
    },
    async updateExciseFiscalRegister(body, callback){
        await genericService.put(urls.EXCISE_FISCAL_REGISTER, body).then(callback);
    },
    async calculatorExciseFiscalRegister(body, callback){
        await genericService.post(urls.EXCISE_FISCAL_REGISTER_CALCULATOR, body).then(callback);
    },
    async addExciseFiscalRegisterByHeaderId(body, callback){
        await genericService.post(urls.EXCISE_FISCAL_REGISTER_BY_HEADER, body).then(callback);
    }
}